import { ChatsChannel } from '@features/socket-chats-reworked/types/channel';
import { ChatsContact, type ContactInstance } from '../types/contact';
import { ChatsMessage } from '../types/message';

export const processContacts = (contacts: ChatsContact[]) =>
  contacts.map((contact) => contact);

export const getContactsIds = (
  data: ChatsChannel[] | ChatsMessage[]
): ChatsContact['id'][] | null => {
  if (!data.length) return null;

  return data.map((item) => item?.contact_id || '').filter((item) => Boolean(item));
};

export const createTitle = ({
  name = '',
  surname = '',
}: {
  name?: string;
  patronymic?: string;
  surname?: string;
}) => `${surname} ${name}`;

export const getContactDisplayName = (contact: ContactInstance) =>
  [contact.meta?.full_name?.name, contact.meta?.full_name?.surname]
    .filter(Boolean)
    .join(' ')
    .trim();

export const sortContactsByName = (contacts: ContactInstance[]) =>
  contacts
    .map((contact) => ({ contact, displayName: getContactDisplayName(contact) }))
    .sort((a, b) => {
      if (!a.displayName || !b.displayName) {
        return Number(!a.displayName) - Number(!b.displayName);
      }

      return a.displayName.localeCompare(b.displayName, 'ru');
    })
    .map(({ contact }) => contact);
